import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";
import { Logo } from "@/components/brand/Logo";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-white border-t border-border" data-testid="compliance-footer">
      <div className="container-x py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Logo variant="lockup" height={44} to="/" />
            <p className="mt-5 text-sm text-muted-foreground leading-relaxed max-w-xs">
              A modern Ontario vehicle rental company. Weekly, monthly, and Rental Term Leasing options with transparent pricing and human support.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4">Explore</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/vehicles" className="hover:text-foreground">Browse vehicles</Link></li>
              <li><Link to="/drive-alfa-club" className="hover:text-foreground">Drive Alfa Club</Link></li>
              <li><Link to="/alfa-one-path" className="hover:text-foreground">Business — Alfa One Path</Link></li>
              <li><Link to="/about#how-it-works" className="hover:text-foreground">How it works</Link></li>
              <li><Link to="/about" className="hover:text-foreground">About</Link></li>
              <li><Link to="/about#contact" className="hover:text-foreground">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4">Account</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/login" className="hover:text-foreground">Sign in</Link></li>
              <li><Link to="/signup" className="hover:text-foreground">Create account</Link></li>
              <li><Link to="/portal" className="hover:text-foreground">Customer Portal</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4">Contact & Support</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 shrink-0" /> <span>Ontario, Canada</span></li>
              <li className="flex items-start gap-2"><Mail className="h-4 w-4 mt-0.5 shrink-0" /> <span>admin@alfadrive.ca</span></li>
              <li className="flex items-start gap-2"><Phone className="h-4 w-4 mt-0.5 shrink-0" /> <span>24/7 customer agent line — coming online soon</span></li>
            </ul>
            <p className="mt-4 text-xs text-muted-foreground leading-relaxed">
              All emails answered in 20 minutes or less by a real human. We’ll call you back if it’s faster.
            </p>
          </div>
        </div>

        {/* Policies + copyright */}
        <div className="mt-12 pt-8 border-t border-border">
          <div className="text-xs text-muted-foreground">
            <div className="text-[11px] uppercase tracking-widest text-foreground font-semibold">Policies</div>
            <ul className="mt-2 flex flex-wrap gap-x-6 gap-y-1">
              <li><Link to="#" className="hover:text-foreground">Privacy Policy</Link></li>
              <li><Link to="#" className="hover:text-foreground">Terms of Service</Link></li>
              <li><Link to="#" className="hover:text-foreground">Cancellation Policy</Link></li>
              <li><Link to="#" className="hover:text-foreground">Insurance & Coverage</Link></li>
            </ul>
            <p className="mt-3 text-[11px] leading-relaxed max-w-2xl">
              AlfaDrive Rentals Inc. is committed to transparent pricing. All rentals subject to eligibility, deposit, valid driver’s licence, and applicable Ontario law.
            </p>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <p className="text-xs text-muted-foreground">
              © {year} AlfaDrive Rentals Inc. — Serving customers across Ontario.
            </p>
            <p className="text-xs text-muted-foreground">
              Made in Canada. Dare to Live.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
